<template>
  <div class="send-msg">
    <div class="query-select">
      <p class="area">{{area}}</p>
      <div v-for="model in models" :key="model.name">
        <span>{{model.name}}</span>
        <el-select v-model="model.value" clearable placeholder="请选择">
          <el-option
            v-for="item in model.options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>

    <div class="send-title">
      <p>消息标题</p>
      <el-input placeholder="请输入标题" v-model="title" clearable></el-input>
    </div>
    <div class="send-content">
      <p>消息内容</p>
      <el-input
        placeholder="请输入内容"
        v-model="content"
        clearable
        type="textarea"
        maxlength="100"
        show-word-limit
        :autosize="{ minRows: 6, maxRows: 6 }"
      ></el-input>
    </div>

    <div class="submit">
      <button @click="submit">确认提交</button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      area: "东坡区",
      models: [
        {
          name: "乡镇",
          value: "",
          options: [
            {
              value: "选项1",
              label: "黄金糕"
            },
            {
              value: "选项2",
              label: "双皮奶"
            }
          ]
        },
        { name: "村/社区", value: "" },
        { name: "人名", value: "" }
      ],
      title: "",
      content: ""
    };
  },
  methods: {
    submit() {}
  }
};
</script>
<style lang='scss' scoped>
.send-msg {
  .submit {
    button {
      border: none;
      padding: 0.2rem 0.8rem;
      font-size: 0.28rem;
      color: #fff;
      background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
      border-radius: 0.08rem;
    }
    margin-top: 1rem;
    text-align: center;
  }
  .send-content,
  .send-title {
    padding: 0.2rem;
    font-weight: bold;
    font-size: 0.32rem;
    line-height: 2;
  }
  .query-select {
    div {
      span {
        width: 20%;
        text-align: center;
        margin-right: 0.2rem;
      }
      .el-select {
        width: 70%;
      }
      align-items: center;
      display: flex;
      line-height: 3;
    }
    .area {
      text-align: center;
      line-height: 3;
    }
  }
  padding-top: 1rem;
  font-size: 0.3rem;
  background: #fff;
  min-height: 100vh;
}
</style>

<style lang="scss">
.send-msg {
  .el-select {
    input {
      font-size: 0.3rem;
    }
  }
}
</style>